import { useNavigate } from "react-router-dom";
import classes from "./Post.module.css";
import { useRef, useState } from "react";

const Post = ({data, deletePost}) => {
      const [showModal , setShowModal ] = useState(false);
    
    const navigate = useNavigate();
    const callDeletePosthandler = () => {
      closeButtonRef.current.click();
      return deletePost(data._id);
    }
    const closeButtonRef = useRef();
  return (
      <>
      {/* Delete Confirmation Modal */}
{showModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
    <div className="bg-gray-800 text-white rounded-lg shadow-xl w-full max-w-md">
      <div className="flex justify-between items-center border-b border-gray-600 px-6 py-4">
        <h5 className="text-lg font-semibold">Delete Post</h5>
        <button
          onClick={() => setShowModal(false)}
          aria-label="Close"
          className="text-white text-xl hover:text-gray-300"
        >
          &times;
        </button>
      </div>
      <div className="px-6 py-4">
        Are you sure you want to delete this post?
      </div>
      <div className="flex justify-end px-6 py-4 border-t border-gray-600">
        <button
          ref={closeButtonRef}
          onClick={callDeletePosthandler}
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded text-sm"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}

{/* Post Card */}
<div className="bg-gray-800 rounded-lg shadow-md p-4 mb-4 text-white">
  <div className="mb-2">
    <h5 className="text-lg font-semibold">{data.name}</h5>
    <p className="text-sm text-gray-300">
      {data.content.length > 280
        ? data.content.substring(0, 281) + '...'
        : data.content}
    </p>
  </div>

  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
    {/* Post Status */}
    <div>
      {data.status === 'publish' && data.scheduled === 0 && (
        <span className="inline-block bg-green-600 text-white text-xs font-medium px-3 py-1 rounded-full">
          Published
        </span>
      )}
      {data.status === 'publish' && data.scheduled === 1 && (
        <span className="inline-block bg-blue-500 text-white text-xs font-medium px-3 py-1 rounded-full">
          Scheduled for publish
        </span>
      )}
      {data.status === 'draft' && (
        <span className="inline-block bg-yellow-500 text-white text-xs font-medium px-3 py-1 rounded-full">
          Draft
        </span>
      )}
    </div>

    {/* Action Buttons */}
    <div className="flex gap-3 mt-3 sm:mt-0">
      <button
        onClick={() => navigate(`/panel/post/edit/${data._id}`)}
        className="bg-gray-700 hover:bg-gray-600 text-white text-sm px-3 py-1 rounded flex items-center gap-2"
      >
        <i className="fa fa-edit"></i> Edit
      </button>
      <button
        onClick={() => setShowModal(true)}
        className="bg-gray-700 hover:bg-gray-600 text-white text-sm px-3 py-1 rounded flex items-center gap-2"
      >
        <i className="fa fa-trash"></i> Delete
      </button>
    </div>
  </div>
</div>

    </>

  );
};

export default Post;
